import React, { Component } from 'react';
import { Waypoint } from 'react-waypoint';
import { connect } from 'react-redux';
import { fetchScreenshots, postScreenshot} from '../redux/actions';
import { userSelector, screenshotSelector, rankSelector, chapterSelector, authSelector } from '../redux/selectors'
import { toArray } from '../common/util';
import Masonry from 'react-masonry-css';
import ScreenshotsItem from './ScreenshotsItem';
import { Button, Collapse } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { hasPermission } from "../common/permissions";
import ScreenshotsForm from './ScreenshotsForm';

class Screenshots extends Component {
    constructor(props) {
        super(props);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            open: false
        };
    }

    componentDidMount() {
        document.title = "Addiction | Screenshots";
    }

    handleUpdate() {
        if (!this.props.screenshots.pending && this.props.screenshots.more) {
            this.props.getScreenshots(this.props.screenshots.page);
        }
    }

    handleSubmit = (values) => {
        
        let newValues = {
            ...values,
            image: this.state.image,
            involved: []
        }
        this.props.uploadScreenshot(newValues);
        this.setState({
            image: null,
            open: !this.state.open
        })
    }

    handleDrop = dropped => {
        this.setState({ image: dropped[0] })
    };

    breakpointColumnsObj = {
        default: 5,
        1100: 4,
        700: 2,
        500: 1
    };

    setEditorRef = (editor) => this.editor = editor;

    render() {
        const screenshotItems = toArray(this.props.screenshots.data)
            .sort((a, b) => (new Date(b.created).getTime() - new Date(a.created).getTime()))
            .map((screenshot) => (
            <div key={`${screenshot.id}-screenshot`}>
                <ScreenshotsItem screenshot={screenshot} users={this.props.users} ranks={this.props.ranks} chapters={this.props.chapters} />
            </div>
        ));
        

        return (
            <div>
                {(hasPermission('multimedia.add_screenshot', this.props.auth.permissions)) ? (
                    <Button className="pull-right" onClick={() => this.setState({ open: !this.state.open })}><FontAwesomeIcon className="text-primary" icon={faPlus} fixedWidth /> Add a Screenshot</Button>
                ) : null
                }
                <h1>Screenshots</h1>
                <Collapse in={this.state.open}>
                    <div>
                        <div className="panel-adt">
                            <ScreenshotsForm 
                                chapters={this.props.chapters}
                                setEditorRef={this.setEditorRef}
                                handleDrop={this.handleDrop}
                                image={this.state.image}
                                onSubmit={this.handleSubmit}
                                errors={this.props.errors}
                                initialValues={{
                                    chapter: toArray(this.props.chapters).sort((a, b) => (b.id - a.id)).shift().id
                                }}
                            />
                        </div>
                    </div>
                </Collapse>
                <Masonry
                    breakpointCols={this.breakpointColumnsObj}
                    className="adt-gallery"
                    columnClassName="adt-gallery-column"
                >
                    {screenshotItems}
                </Masonry>

                <div>
                    <Waypoint
                        key="waypoint"
                        onEnter={this.handleUpdate}
                        bottomOffset='-10%'
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    auth: authSelector(state),
    screenshots: screenshotSelector(state),
    ranks: rankSelector(state),
    users: userSelector(state),
    chapters: chapterSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getScreenshots: (page) => dispatch(fetchScreenshots(page)),
    uploadScreenshot: (values) => dispatch(postScreenshot(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Screenshots);


// WEBPACK FOOTER //
// ./src/Media/Screenshots.js